"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MoreDetailRequest = void 0;
var MoreDetailRequest = /** @class */ (function () {
    function MoreDetailRequest() {
    }
    return MoreDetailRequest;
}());
exports.MoreDetailRequest = MoreDetailRequest;
;
//# sourceMappingURL=moreDetail.request.js.map